<template>
  <div class="app-download">
    <img class="app-icon" src="@images/app-download/ico_app.png" alt="appIcon" />
    <a class="app-store" :href="appStore" target="_blank"><img :src="require(`@images/app-download/${lang}/appstore-lrg.png`)" height="76" alt="app store" /></a>
    <a class="google-play" :href="googlePlay" target="_blank"><img :src="require(`@images/app-download/${lang}/google-play-badge.png`)" height="76" alt="google play" /></a>
  </div>
</template>

<script>
import { languages, getLocaleKey } from '@constants'

const appStoreLinks = {
  'ja-JP': 'https://itunes.apple.com/jp/app/id1181774280',
  'en-US': 'https://itunes.apple.com/app/id1181774280',
  'en-GB': 'https://itunes.apple.com/gb/app/id1181774280',
  'de-DE': 'https://itunes.apple.com/de/app/id1181774280',
  'fr-FR': 'https://itunes.apple.com/fr/app/id1181774280',
  'fr-CA': 'https://itunes.apple.com/ca/app/id1181774280?l=fr',
  'es-ES': 'https://itunes.apple.com/es/app/id1181774280',
  'es-MX': 'https://itunes.apple.com/mx/app/id1181774280',
  'it-IT': 'https://itunes.apple.com/it/app/id1181774280',
  'zh-TW': 'https://itunes.apple.com/tw/app/id1181774280',
  'pt-BR': 'https://itunes.apple.com/pt/app/id1181774280',
}
const googlePlayLink = 'https://play.google.com/store/apps/details?id=com.nintendo.zaba'

export default {
  name: 'appDownload',
  computed: {
    lang() {
      let lang
      if (languages.enums.find(l => l.value === this.$route.params.lang)){
        lang = this.$route.params.lang
      } else {
        lang = languages.get(getLocaleKey()).value
      }
      return lang
    },
    appStore() {
      return appStoreLinks && this.$route.params ? appStoreLinks[this.$route.params.lang] : null
    },
    googlePlay() {
      return googlePlayLink
    }
  },
}
</script>

<style lang="scss" scoped>
.app-download {
  margin-top: 80px;
  display: flex;
  justify-content: center;
  > .app-icon {
    width: 83px;
    margin-right: 10px;
  }
  > .app-store {
    margin-right: 10px;
  }
  > .app-store,
  > .google-play {
    display: block;
    height: 76px;
  }
}
</style>
